import { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LicenceContext = createContext(null);

export function LicenceProvider({ children }) {
  const [licence, setLicence] = useState(null);

  useEffect(() => {
    axios.get(`${API}/licence/status`, { withCredentials: true })
      .then(res => setLicence(res.data))
      .catch(() => {});
  }, []);

  return <LicenceContext.Provider value={licence}>{children}</LicenceContext.Provider>;
}

export function useLicence() {
  return useContext(LicenceContext);
}

export function canAccess(licence, feature) {
  if (!licence) return true; // Loading
  if (licence.licence_status === 'trial' && !licence.trial_expired) return true;
  return licence.tier_features?.[feature] !== false;
}
